import { createSelector } from 'reselect';

export const getIsWorkflowListLoading = (state) =>
  state.appMigration.export.workflowsList.isLoading || false;
export const getWorkflows = (state) => state.appMigration.export.workflowsList.data ?? [];
export const getChangedItems = (state) => state.appMigration.export.changedItemsList.data ?? [];

export const getWarnings = (state) => state.warnings;

export const getLookupError = createSelector(
  [getWarnings, (_, params) => params.rowId],
  (warnings, rowId) => warnings.find((warning) => warning.instanceId === rowId)
);
